import { apiClient } from "@/api";

export const WeatherApi = {
  /**
   * Получение данных о погоде
   * @returns {Promise<Object>} - Данные о погоде
   */
  async getWeather() {
    return apiClient.get("/weather");
  },
};
